import { Reducer, Action } from 'redux'
import {
  SORT_FIELD,
  SORT_ORDER,
  ISpotBiddingConfigsState,
  ISpotBiddingConfig,
  ISpotBiddingConfigsFilterState,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import {
  GET_SPOT_BIDDING_CONFIG_LIST_ACTION_TYPES,
  UPDATE_CONFIG_FILTERS,
  UPDATE_PAGE_COUNT,
} from 'apps/spot-quote-control-panel/utils/actions/spotBiddingConfigList'

const {
  GET_SPOT_BIDDING_CONFIG_LIST_FAILURE,
  GET_SPOT_BIDDING_CONFIG_LIST_REQUEST,
  GET_SPOT_BIDDING_CONFIG_LIST_SUCCESS,
} = GET_SPOT_BIDDING_CONFIG_LIST_ACTION_TYPES

const defaultState: ISpotBiddingConfigsState = {
  fetching: false,
  spotBiddingConfigs: [],
  totalCount: 0,
  params: {
    pageCount: 0,
    perPage: 50,
    sortField: SORT_FIELD.CONFIG_NAME,
    sortOrder: SORT_ORDER.ASC,
    filters: {},
  },
}

interface ISuccessAction extends Action<string> {
  payload: {
    spotBiddingConfigs: ISpotBiddingConfig[]
    totalCount: number
  }
}

interface IErrorAction extends Action<string> {
  error: string
}

interface IFilterAction extends Action<string> {
  payload: {
    filters: ISpotBiddingConfigsFilterState
  }
}

interface IPageAction extends Action<string> {
  payload: {
    pageCount: number
  }
}

type SpotBiddingConfigsAction = ISuccessAction | IErrorAction | IFilterAction | IPageAction

const spotBiddingConfigListReducer: Reducer<ISpotBiddingConfigsState, SpotBiddingConfigsAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case GET_SPOT_BIDDING_CONFIG_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case GET_SPOT_BIDDING_CONFIG_LIST_SUCCESS: {
      const {
        payload: { spotBiddingConfigs, totalCount },
      } = action as ISuccessAction
      return {
        ...state,
        fetching: false,
        spotBiddingConfigs,
        totalCount,
      }
    }
    case GET_SPOT_BIDDING_CONFIG_LIST_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }
    case UPDATE_CONFIG_FILTERS: {
      const {
        payload: { filters },
      } = action as IFilterAction
      return {
        ...state,
        params: {
          ...state.params,
          filters,
        },
      }
    }
    case UPDATE_PAGE_COUNT: {
      const {
        payload: { pageCount },
      } = action as IPageAction
      return {
        ...state,
        params: {
          ...state.params,
          pageCount,
        },
      }
    }
    default:
      return state
  }
}

export default spotBiddingConfigListReducer
